<template>
  <vs-prompt
    title="修改密码"
    @close="closeHandle"
    class="active-prompt"
    buttons-hidden
    :active.sync="dialogShow">
    <div class="con-exemple-prompt">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        label-position="right"
      >
        <el-form-item
          label="原密码"
          prop="orginPass"
        >
          <el-input
            type="password" show-password
            placeholder="请输入原密码"
            v-model.trim="form.orginPass"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPass"
        >
          <el-input
            type="password" show-password
            placeholder="请输入新密码"
            v-model.trim="form.newPass"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认新密码"
          prop="comfirmPass"
        >
          <el-input
            type="password" show-password
            placeholder="请确认新密码"
            v-model.trim="form.comfirmPass"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-modules">
        <el-button
          type="primary"
          @click="submitHandle"
          :loading="loading"
        >提交</el-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { clearLoginInfo } from '@/utils/index'
import { mapGetters } from 'vuex'
import { editPass } from '@/api/user.js';
export default {
  name: "activeCodeDialog",
  data() {
    let _this = this;
    let comfirmPassValidator = (rule, value, callback) => {
      if(value === ''){
        callback(new Error('请输入确认密码'));
      }else {
        if(_this.form.newPass !== value){
          callback(new Error('两次密码不一样'));
        }else {
          callback()
        }
      }
    };
    return {
      dialogShow: false,
      form: {
        orginPass: '',
        newPass: '',
        comfirmPass: '',
      },
      rules: {
        orginPass: [
          {required: true, message: '请输入原密码', trigger: 'blur'},
        ],
        newPass: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
        ],
        comfirmPass: [
          {required: true,validator: comfirmPassValidator, trigger: 'blur'},
        ],
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    candelHandle() {
      this.$refs.form.resetFields();
      this.dialogShow = false;
    },
    closeHandle(){
      this.dialogShow = false;
      this.$refs.form.resetFields();
    },
    submitHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          let params = {
            'password': this.form.orginPass,
            'newPassword': this.form.newPass
          };
          this.loading = true;
          editPass(params).then((data) => {
            this.loading = false;
            this.dialogShow = false;
            if(data&&data.code&&data.code == 200){
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(() => {
                clearLoginInfo();
                localStorage.clear();
                this.$router.push({name: 'login'});
              },200);
            }else{
              this.$message.error(data.msg);
            }
          }).catch((error) => {
            console.log(error);
            this.loading = false;
          });
        }
      })
    }
  },
}
</script>

<style lang="scss">
@import "../../../../assets/scss/variable";
.active-prompt.con-vs-dialog {
  .con-exemple-prompt {
    padding-top: 10px;
    padding-right: 20px;
  }
  z-index: 1001;
  .vs-dialog .vs-dialog-header .dialog-title {
    color: $themefontcolor;
  }
  .vs-dialog {
    width: 614px;
    max-width: none;

    .vs-dialog-header .dialog-title {
      color: $themefontcolor;
    }

    .vs-dialog-text {
      //padding: 0 !important;
    }
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .btn-modules {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
